import React from 'react';
import { withRouter } from 'found';
import { commitMutation, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import documentStyles from '../Document.scss';
import { Loader } from '../../Elements';
import styleVariables from '../../variables';
import Header from './Header';
import MobileSidebar from 'react-sidebar';
import Sidebar from '../../App/SidebarComponent';
import NotFound from '../../App/404';
import {
  Button,
  Container,
  Divider,
  Grid,
  Icon,
  Rail,
  Segment
} from 'semantic-ui-react';
import Actions from './Actions';
import Schedule from './Schedule';
import LineItems from './LineItems';
import Library from './Library';
import Brand from './Brand';
import Logo from './Logo';
import Terms from './Terms';
import Sign from './Sign';
import SignatureBlocks from './SignatureBlocks';

const Contract = class Contract extends React.Component {
  static propTypes = {
    signer: PropTypes.object,
    location: PropTypes.object.isRequired,
    node: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    viewer: PropTypes.object,
    params: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.canEdit = this.canEdit.bind(this);
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.openSignModal = this.openSignModal.bind(this);
    this.closeSignModal = this.closeSignModal.bind(this);
    this.getSigner = this.getSigner.bind(this);
    this.getAlreadySigned = this.getAlreadySigned.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

    this.state = {
      error: !this.props.node,
      sidebarOpen: false,
      signModalOpen: false
    };
  }

  componentWillMount() {
    this.updateWindowDimensions();
    if (!this.props.node && this.props.location.query.share_token) this.addContractToSession();
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  onSetSidebarOpen(open) {
    this.setState({ sidebarOpen: open });
  }

  getAlreadySigned() {
    let alreadySigned = 0;
    this.props.node.contract_signature_blocks.edges.map(signatureBlock => {
      if (signatureBlock.node.signed_at) {
        ++alreadySigned;
      }
      return signatureBlock;
    });
    return alreadySigned;
  }

  getSigner() {
    let signer = null;
    if (this.props.node) {
      this.props.node.contract_signature_blocks.edges.map(signatureBlock => {
        if (signatureBlock.node.id === this.props.params.signer_id) {
          signer = signatureBlock.node;
        }
        return signatureBlock;
      });
    }
    return signer;
  }

  addContractToSession() {
    this.setState({ error: false });
    const onCompleted = () => {
      this.props.relay.refetch(
        (fragmentVariables) => fragmentVariables, null
      );
    };

    const onError = () => {
      this.setState({ error: true });
    };

    const mutation = graphql`
      mutation ContractComponent_addContractToSessionMutation(
        $input: AddContractToSessionInput!
      ) {
        addContractToSession(input: $input) {
          contract {
            id
          }
        }
      }
    `;

    const environment = this.props.relay.environment;
    const { share_token } = this.props.location.query;

    commitMutation(environment, {
      mutation,
      variables: { input: { share_token } },
      onCompleted,
      onError
    });
  }

  toggleSidebar(ev) {
    ev.preventDefault();
    this.onSetSidebarOpen(!this.state.sidebarOpen);
  }

  canEdit() {
    return (
      this.props.node.can_edit &&
      this.props.node.editable &&
      this.props.params.action === 'edit'
    );
  }

  openSignModal() {
    this.setState({ signModalOpen: true });
  }

  closeSignModal() {
    this.setState({ signModalOpen: false });
  }

  updateWindowDimensions() {
    this.setState({
      window: { width: window.innerWidth, height: window.innerHeight }
    });
  }

  render() {
    const CheckIcon = (
      <Icon name='check circle' color='green' style={{ marginLeft: '0.5em' }} />
    );
    const StartSigningButtonDesktop = (
      <Button
        content='Start Signing'
        size='large'
        className={documentStyles.actionButton}
        style={
          this.getSigner() && this.getSigner().signed_at
            ? { display: 'none' }
            : {}
        }
        onClick={this.openSignModal}
      />
    );

    const StartSigningButtonMobile = (
      <Button
        content='Start Signing'
        fluid
        primary
        size='big'
        style={
          this.getSigner() && this.getSigner().signed_at
            ? { display: 'none' }
            : {}
        }
        onClick={this.openSignModal}
      />
    );

    const signer = this.getSigner();

    const isLargeScreen = this.state.window.width >= 1280;

    const ActionsMenu = (
      <Actions
        node={this.props.node}
        params={this.props.params}
        relay={this.props.relay}
        router={this.props.router}
        windowDimensions={this.state.window}
      />
    );

    return (
      <div>
        {this.props.node &&
          <MobileSidebar
            sidebar={
              <Sidebar
                setSidebarOpenState={this.onSetSidebarOpen}
                router={this.props.router}
                viewer={this.props.viewer}
              />
            }
            sidebarClassName={documentStyles.sidebar}
            open={this.state.sidebarOpen}
            onSetOpen={this.onSetSidebarOpen}
            touch={false}
            contentClassName={documentStyles.mobileSidebarContent}
            rootClassName={documentStyles.mobileSidebarRoot}
          >
            {!signer &&
              <Header
                toggleSidebar={this.toggleSidebar}
                sidebarOpen={this.state.sidebarOpen}
                document={this.props.node}
                relay={this.props.relay}
                router={this.props.router}
                params={this.props.params}
                viewer={this.props.viewer}
                windowDimensions={this.state.window}
              />}
            <Container
              className={[
                documentStyles.container,
                signer ? documentStyles.documentOffset : ''
              ].join(' ')}
            >
              {!isLargeScreen && this.state.window.width >= styleVariables.tabletBreakpoint &&
                <Grid>
                  <Grid.Row columns='equal' className={documentStyles.actionsMenuTablet}>
                    <Grid.Column>
                      {!signer && ActionsMenu}
                    </Grid.Column>
                  </Grid.Row>
                </Grid>}
              <Segment className={documentStyles.segment}>
                {isLargeScreen &&
                  <Rail position='right' close className={documentStyles.actionsMenuDesktop}>
                    {!signer && ActionsMenu}
                  </Rail>}
                <Grid padded relaxed stackable>
                  <Grid.Row columns='equal'>
                    <Grid.Column>
                      <Logo
                        canEdit={this.canEdit()}
                        viewer={this.props.viewer}
                        node={this.props.node}
                        relay={this.props.relay}
                      />
                      <Brand
                        canEdit={this.canEdit()}
                        viewer={this.props.viewer}
                        node={this.props.node}
                        relay={this.props.relay}
                      />
                    </Grid.Column>
                    <Grid.Column />
                  </Grid.Row>
                  {(this.canEdit() ||
                    this.props.node.contract_event_segments.edges.length > 0) &&
                    <Grid.Row className={documentStyles.section}>
                      <Grid.Column width={16}>
                        <Divider horizontal className={documentStyles.heading}>
                          Schedule
                        </Divider>
                      </Grid.Column>
                    </Grid.Row>}
                  {(this.canEdit() ||
                    this.props.node.contract_event_segments.edges.length > 0) &&
                    <Grid.Row columns='equal'>
                      <Grid.Column>
                        <Schedule
                          eventSegments={
                            this.props.node.contract_event_segments.edges
                          }
                          viewer={this.props.viewer}
                          relay={this.props.relay}
                          readOnly={!this.canEdit()}
                          node={this.props.node}
                        />
                      </Grid.Column>
                    </Grid.Row>}
                  {(this.canEdit() ||
                    this.props.node.contract_line_items.edges.length > 0) &&
                    <Grid.Row className={documentStyles.section}>
                      <Grid.Column width={16}>
                        <Divider horizontal className={documentStyles.heading}>
                          Line Items
                        </Divider>
                      </Grid.Column>
                    </Grid.Row>}
                  {(this.canEdit() ||
                    this.props.node.contract_line_items.edges.length) > 0 &&
                    <Grid.Row columns='equal' className={documentStyles.section}>
                      <Grid.Column>
                        <LineItems
                          node={this.props.node}
                          relay={this.props.relay}
                          canEdit={this.canEdit()}
                        />
                      </Grid.Column>
                    </Grid.Row>}
                  {this.canEdit() &&
                    <Grid.Row columns='equal'>
                      <Grid.Column>
                        <Library
                          node={this.props.node}
                          relay={this.props.relay}
                          viewer={this.props.viewer}
                        />
                      </Grid.Column>
                    </Grid.Row>}
                  {(this.canEdit() || this.props.node.terms) &&
                    <Grid.Row className={documentStyles.section}>
                      <Grid.Column width={16}>
                        <Divider horizontal className={documentStyles.heading}>
                          Terms and Conditions
                        </Divider>
                      </Grid.Column>
                    </Grid.Row>}
                  <Grid.Row columns='equal' className={documentStyles.section}>
                    <Grid.Column>
                      <Terms
                        node={this.props.node}
                        relay={this.props.relay}
                        canEdit={this.canEdit()}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  {(this.canEdit() ||
                    this.props.node.contract_signature_blocks.edges.length > 0) &&
                    <Grid.Row className={documentStyles.section}>
                      <Grid.Column width={16}>
                        <Divider horizontal className={documentStyles.heading}>
                          Signatures
                        </Divider>
                      </Grid.Column>
                    </Grid.Row>}
                  <Grid.Row columns='equal'>
                    <Grid.Column>
                      <SignatureBlocks
                        relay={this.props.relay}
                        node={this.props.node}
                        canEdit={this.canEdit()}
                        signer={this.getSigner()}
                        openSignModal={this.openSignModal}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
            </Container>
            {signer &&
              <div>
                {this.state.window.width >= styleVariables.tabletBreakpoint &&
                  <div
                    className={[
                      documentStyles.actionPromptDesktop,
                      signer.signed_at ? documentStyles.actionPromptCompleted : ''
                    ].join(' ')}
                  >
                    <Container>
                      {!signer.signed_at &&
                        <span>
                          {signer.name &&
                            <span>
                              <strong>{signer.name},</strong> this contract is ready
                              for you to sign.
                            </span>}
                          {!signer.name &&
                            <span>This contract is ready for you to sign.</span>}
                        </span>}
                      {signer.signed_at &&
                        <span>
                          {signer.name &&
                            <p>
                              {signer.name}, you have signed this contract {CheckIcon}
                            </p>}
                          {!signer.name &&
                            <p>
                              You have signed this contract {CheckIcon}
                            </p>}
                        </span>}
                      <Sign
                        relay={this.props.relay}
                        signatureBlock={signer}
                        trigger={StartSigningButtonDesktop}
                        contract={this.props.node}
                        open={this.state.signModalOpen}
                        onClose={this.closeSignModal}
                        onOpen={this.openSignModal}
                      />
                    </Container>
                  </div>
                }
                {this.state.window.width < styleVariables.tabletBreakpoint &&
                  <div
                    className={[
                      documentStyles.actionPromptMobile,
                      signer.signed_at ? documentStyles.actionPromptCompleted : ''
                    ].join(' ')}
                  >
                    <Sign
                      relay={this.props.relay}
                      signatureBlock={signer}
                      trigger={StartSigningButtonMobile}
                      contract={this.props.node}
                      open={this.state.signModalOpen}
                      onClose={this.closeSignModal}
                      onOpen={this.openSignModal}
                    />
                    {signer.signed_at &&
                      <p style={{ padding: '1em' }}>
                        You have signed this contract {CheckIcon}
                      </p>}
                  </div>
                }
              </div>}
          </MobileSidebar>
        }
        {!this.props.node &&
          <div>
            {this.state.error &&
              <NotFound viewer={this.props.viewer} />}
            {!this.state.error && <Loader />}
          </div>
        }
      </div>
    );
  }
};

export default withRouter(Contract);



// WEBPACK FOOTER //
// ./webpack/components/Document/Contract/ContractComponent.js